import type { CSSProperties, ReactNode } from 'react';
import { DataTable } from 'primereact/datatable';

export const DATA_MANAGEMENT_PAGE_SIZE = 10;

interface DataManagementDataTableProps<T extends object[]> {
  value: T;
  dataKey: string;
  page: number;
  totalRecords: number;
  loading: boolean;
  emptyMessage: string;
  onPage: (page: number) => void;
  tableStyle?: CSSProperties;
  scrollable?: boolean;
  children: ReactNode;
}

const DataManagementDataTable = <T extends object[],>({
  value,
  dataKey,
  page,
  totalRecords,
  loading,
  emptyMessage,
  onPage,
  tableStyle = { minWidth: 'max-content', background: '#fff' },
  scrollable = false,
  children,
}: DataManagementDataTableProps<T>) => (
  <DataTable
    className="data-management-table"
    value={value}
    dataKey={dataKey}
    lazy
    paginator
    first={(page - 1) * DATA_MANAGEMENT_PAGE_SIZE}
    rows={DATA_MANAGEMENT_PAGE_SIZE}
    totalRecords={totalRecords}
    onPage={event => onPage(Math.floor(event.first / DATA_MANAGEMENT_PAGE_SIZE) + 1)}
    loading={loading}
    emptyMessage={emptyMessage}
    resizableColumns
    columnResizeMode="expand"
    stripedRows
    scrollable={scrollable}
    tableStyle={tableStyle}
  >
    {children}
  </DataTable>
);

export default DataManagementDataTable;